import { render, staticRenderFns } from "./commonFrame.vue?vue&type=template&id=4a33e55c&scoped=true&"
import script from "./commonFrame.vue?vue&type=script&lang=js&"
export * from "./commonFrame.vue?vue&type=script&lang=js&"
import style0 from "./commonFrame.vue?vue&type=style&index=0&id=4a33e55c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a33e55c",
  null
  
)

export default component.exports